"use client"

import Image from "next/image"

const MAKERS = [
  { name: "David Thompson", avatar: "/p/logomaker-user-1.jpeg" },
  { name: "Michael Harden", avatar: "/p/logomaker-user-2.jpeg" },
  { name: "James Rodriguez", avatar: "/p/logomaker-user-3.jpeg" },
  { name: "Emma Wilson", avatar: "/p/logomaker-user-4.jpeg" },
  { name: "Sophie Laurent", avatar: "/p/logomaker-user-5.jpeg" },
]

const STATS = [
  { value: "8,000+", label: "Logos designed" },
  { value: "4,000+", label: "Brands started here" },
  { value: "30 sec", label: "From brief to mark" },
]

export default function SocialProof() {
  return (
    <section id="trust" className="border-b border-line">
      <div className="container">
        <div className="flex flex-col gap-8 py-10 md:flex-row md:items-center md:justify-between md:gap-12">
          <div className="flex items-center gap-4">
            <div className="flex -space-x-2">
              {MAKERS.map((maker) => (
                <span
                  key={maker.name}
                  className="relative size-9 overflow-hidden rounded-full border-2 border-paper"
                >
                  <Image src={maker.avatar} alt="" fill className="object-cover" />
                </span>
              ))}
            </div>
            <p className="max-w-[16rem] text-small text-ink-muted text-pretty">
              Founders, shops and side projects have made their mark here.
            </p>
          </div>

          <dl className="grid grid-cols-3 gap-6 md:gap-12">
            {STATS.map((stat) => (
              <div key={stat.label} className="flex flex-col gap-1">
                <dt className="type-eyebrow order-2">{stat.label}</dt>
                <dd className="order-1 font-display text-h3 tabular-nums">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  )
}
